kv.controller('domainCategoryEditCtrl', function ($uibModalInstance, data, $injector, $scope) {
	return new dictionaryEditCtrl($uibModalInstance, data, $injector, $scope, {
		entity: "domain_category",
		primaryKey: "domain_category_id",
		newEntity:{
		},
		prepareDataToSave: function () {
			let cmdate = this.getInjection('cmdate');
			let dataToSend = angular.copy(this.data);
			dataToSend.date = cmdate.toServer(this.data.date);
			return dataToSend;
		}
	});
});